import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType } from 'app/enum/Particles';
import ParticleBehaviourLookup from './ParticleBehaviourLookup';

export class ParticleBehaviourManager {
	//Prop objects:
	protected _sceneProps: particles.SceneProps;
	protected _particleProps: particles.ParticleProps;
	protected _animatedProps: particles.ParticleProperties;

	//Behaviour instances:
	private _behaviours: Array<particles.ParticleBehaviour> = [];
	private _i: number = 0;

	constructor(
		sceneProps: particles.SceneProps,
		particleProps: particles.ParticleProps,
		animatedProps: particles.ParticleProperties
	) {
		this._sceneProps = sceneProps;
		this._particleProps = particleProps;
		this._animatedProps = animatedProps;
	}

	public tick(): void {

		for (let i = 0, n = this._behaviours.length; i < n; i++) {
			if (this._behaviours[i]._active) {
				this._behaviours[i].tick();
			}
		}
	}

	public resize(): void {
		for (this._i = 0; this._i < this._behaviours.length; this._i++) {
			this._behaviours[this._i].resize();
		}
	}

	public destroy(): void {
		this._behaviours.forEach((behaviour) => this._destroyBehaviour(behaviour));
		this._behaviours = null;
		this._sceneProps = this._particleProps = this._animatedProps = null;
	}

	//PUBLIC METHODS
	//--------------------------------------------------------------------------------------------------
	//https://www.typescriptlang.org/docs/handbook/generics.html

	public add<T extends particles.ParticleBehaviour>(classname: {
		new (s: particles.SceneProps, p: particles.ParticleProps, a: particles.ParticleProperties): T;
	}): T {
		let behaviour: T = new classname(this._sceneProps, this._particleProps, this._animatedProps);
		ParticleBehaviourLookup.add(behaviour);
		this._behaviours.push(behaviour);
		return behaviour;
	}

	public getByTag(tag: ParticleBehaviourTagType): Array<particles.ParticleBehaviour> {
		return this._behaviours.filter((particle) => {
			return particle.hasTag(tag);
		});
	}

	public removeByTag(tag: ParticleBehaviourTagType): void {
		let behaviours: Array<particles.ParticleBehaviour> = this.getByTag(tag);
		behaviours.forEach((behaviour) => this._destroyBehaviour(behaviour));
		this._purgeBehaviours();
	}

	public deactiveAll(): void {
		this._behaviours.forEach((particleBehaviour) => {
			if (particleBehaviour.active) particleBehaviour.active = false;
		});
	}

	//PRIVATE METHODS
	//--------------------------------------------------------------------------------------------------
	private _destroyBehaviour(behaviour: particles.ParticleBehaviour): void {
		behaviour.active = false;
		behaviour.destroy();
	}

	private _purgeBehaviours(): void {
		let i = 0;

		while (i < this._behaviours.length) {
			if (this._behaviours[i].destroyed) {
				this._behaviours.splice(i, 1);
			} else {
				i++;
			}
		}
	}
}
